import { ICON__ban_solid } from '@/assets/icons_fa';
import { path_relative_to_absolute } from '@/utils/utils_files_client';
import { assert_false } from '@shared/asserts/utils_asserts';
import { DTO__image_asset } from '@shared/dto/+image/image_asset_base/DTO__image_asset';
import { useState } from 'react';

interface PROPS {
  image_assets: DTO__image_asset[];
}

export function G_TABLE_CELL__images_preview({ image_assets }: PROPS) {
  image_assets = image_assets.filter(image_asset => !image_asset.is_single_color);
  image_assets = image_assets.filter(image_asset => !image_asset.is_stub());
  /*
   *
   */

  const [is_hovered, set_is_hovered] = useState(false);

  /*
   *
   */

  function render_preview(url: string) {
    if (!is_hovered) return null;

    return (
      <div className="absolute z-20 top-0 left-8 w-20 h-20 pointer-events-none">
        <img src={url} alt="Asset Preview Expanded" className="size-full rounded-sm object-cover border border-gray-300" />
      </div>
    );
  }
  function render_empty() {
    return (
      <div className="w-6 h-6 rounded-xs  flex-center">
        <ICON__ban_solid className="!size-4 text-component-border" />
      </div>
    );
  }

  function render_image(image_asset: DTO__image_asset) {
    assert_false(image_asset.is_stub());

    let url = path_relative_to_absolute(image_asset.url_relative);

    return (
      <div
        key={`G_TABLE_CELL__image_preview_${image_asset.hash_sha256_content}`}
        onMouseEnter={() => set_is_hovered(true)}
        onMouseLeave={() => set_is_hovered(false)}
      >
        <img src={url} alt="Asset Preview" className=" size-6 rounded-sm object-cover border border-component-border cursor-pointer" />
        {render_preview(url)}
      </div>
    );
  }

  /*
   *
   */

  if (image_assets.is_empty()) return render_empty();

  return <div className="relative flex flex-wrap items-center gap-1 shrink-0 w-20">{image_assets.map(render_image)}</div>;
}
